<template>
  <div @click="toChart" class="chatGptMessage">
    <i></i>
    <span>ChatGPT</span>
    <p>
      基于语言模型的聊天机器人仅供内部学习交流使用
      <i></i>
    </p>
  </div>
</template>

<script>
import common from "@common/common";
import * as config from "@common/config";
import store from "@common/store";

export default {
  name: 'chatGptMessage',
  data() {
    return {
      cancel_enable: false,
      showDownLoadBox: false,
      nowLength1: 0,
      show: true,
      r: null,
      user_space: {},
      checkFailTime: 0,
      upload_role: {},
      download_role: {},
      searchOptions: {},
      showDownLoad: false,
      showMission: false,
      quickEdit: true,
      create: {
        interview: false,
        material: false,
        publish: false,
        report: false
      },
      messageList: [],
      uploading: false,
      baseUrl: "",
      appId: "",
      appSecret: "",
      defaultImg: require("@assets/img/common/default.png"),
      defaultMedia: require("@assets/img/common/audioMask.jpg"),
      datePicker: "",
      fillWidth: 0,
      itemHeight: 0,
      page: {
        pageCount: 0,
        pageSize: 20,
        pageIndex: 1,
        total: 0
      },
      qkPage: {
        pageIndex: 1,
        pageSize: 10
      },
      stateList: ["全部", "草稿", "已发布"],
      stateIndex: 0,
      typeList: ["全部", "图片", "视频", "音频"],
      typeIndex: 0,
      dateList: ["全部", "今天", "昨天", "前一周"],
      dateIndex: 0,
      list: [],
      start: "",
      end: "",
      num: 0,
      selectAll: false,
      baseConfig: {
        customered: true,
        autoUploading: true,
        multipleFiles: true,
        retryCount: 3,
        tokenURL: "",
        uploadURL: "",
        postVarsPerFile: {
          appId: "",
          appSecret: ""
        },
        onMaxSizeExceed: f => {
          this.$toast("文件大小超出限制");
        },
        onCancel: f => {
          console.log("cancel", f);
          let id = document.getElementById(f.id).parentNode;
          id.remove();
          let nowLength1 = document.querySelectorAll('.uploadLoadingList .content ul li').length;
          this.nowLength1 = nowLength1
        },
        onExtNameMismatch: () => {
          this.$toast("无法上传不支持的格式");
        }
      },
      pic: {
        // 图片部分数据模型
        types: [],
        assets: []
      },
      video: {
        // 视频部分数据模型
        types: [],
        assets: []
      },
      audio: {
        // 音频部分数据模型
        types: [],
        assets: []
      },
      file: {
        // 文件部分数据模型
        title: "文件",
        description: "",
        stream: null,
        list: [],
        cancelOne: f => {
          if (f.pending) {
            this.deleteAsset(f.idstring, this.file.list);
            return;
          }

          if (this.file.stream) {
            try {
              this.file.stream.cancelOne(f.id);
            } catch (error) {
              console.log("stream取消出错", error);
            }

            this.delItem(this.file.list, f.id);
          }
        },
        config: {
          browseFileId: "httpUpBtn1",
          extFilters: [],
          maxSize: 10 * 1024 * 1024 * 1024,
          onQueueComplete: m => {
            // this.$toast('所有文件已上传完成')
            // this.uploading = false
            // this.passUploading()
          },
          onComplete: f => {
            let messageIndex = null;
            // let id = document.getElementById(f.id).parentNode;
            // id.remove();
            this.file.stream.cancelOne(f.id);

            f.targetPath = JSON.parse(f.msg).targetPath;

            let messageList = Array.from(new Set(this.messageList));

            messageList = messageList.filter(el => {
              return el.status_name != "正在上传";
            });

            store.commit("setMessageList", messageList);

            this.file.list.forEach(i => {
              if (i.id === f.id) {
                i.targetPath = f.targetPath;
                this.$set(i, "hideasset", true);
                this.$set(i, "typeName", "上传成功");
              }
            });

            let nowLength1 = document.querySelectorAll('.uploadLoadingList .content ul li').length;
            this.nowLength1 = nowLength1

            // this.addAssetsToPage([f])
            this.addFilePromises.push(this.addAssetsToPage([f]));
          },
          onUploadError: f => {
            this.$toast("文件上传出错");
            let id = document.getElementById(f.id).parentNode;
            id.remove();
            let nowLength1 = document.querySelectorAll('.uploadLoadingList .content ul li').length;
            this.nowLength1 = nowLength1
          },
          onSelect: f => {
            // 视音频数量限制10个（待添加），超出：stream.stop(), stream.cancel()
            setTimeout(() => {
              f = this.filterFiles(f, this.file.config.maxSize);

              f.forEach(el => {
                console.log(el);
                let name = el.name;
                name = name.split('.');
                let ext = name[name.length-1] 
                el.type_name = "上传素材";
                el.status_name = "正在上传";
                el.msg = name;
                el.type = 0;
                el.status = 0;
                el.ext = ext;
                // el.f = el;
                this.messageList.unshift(el);
                this.pushList(el)
              });

              store.commit("setMessageList", this.messageList);

              let totalList = this.file.list.concat(f);
              console.log(totalList)
              const allTypes = this.pic.types
                .concat(this.video.types)
                .concat(this.audio.types);
              totalList = totalList.filter(i => allTypes.indexOf(i.ext) > -1);
              this.file.list = Array.from(new Set(totalList));
              console.log(this.file.list)
              let nowLength1 = document.querySelectorAll('.uploadLoadingList .content ul li').length;
              this.nowLength1 = nowLength1
            }, 0);
          },
          onUploadProgress: f => {
            this.uploading = true;
            // console.log(f)
            let id = document.getElementById(f.id);
            id.querySelectorAll('.left-container > .line-container > .line')[0].style.width = f.percent + '%'
            id.querySelectorAll('.right-container > span')[0].innerHTML = `${f.formatLoaded}/${f.formatSize}`
            // this.passUploading();
            // this.handleProgress(this.file.list, f);
          }
        }
      },
      aspera: {
        // aspera通道上传
        needInstall: false,
        files: [],
        filetypes: [],
        maxSize: 10 * 1024 * 1024 * 1024,
        checkInstalled: null,
        config: {
          host: "",
          userName: "",
          userPassword: "",
          deviceID: ""
        },
        start: f => {
          console.log("aspera uploading", f);
          const current = {
            remote_host: this.aspera.config.host,
            remote_user: this.aspera.config.userName,
            // remote_user: 'xnews2',
            remote_password: common.hex2str(this.aspera.config.userPassword),
            create_dir: true,
            direction: "send",
            needs_destination: "",
            paths: [
              {
                fileId: f.id,
                fileName: f.filename,
                source: f.name,
                destination: f.serverpath
              }
            ]
          };
          const params = {
            allow_dialogs: false
          };

          fileControls.asperaWeb.startTransfer(current, params, {
            error: responseData => {
              let userMessage = responseData.error.user_message;
              this.$toast(userMessage);
            },
            success: res => {
              console.log("start", res);
              this.messageList.unshift({
                type_name: "上传素材",
                status_name: "正在上传",
                type: 0,
                status: 0,
                fileId: res.transfer_specs[0].transfer_spec.paths[0].fileId,
                name: res.transfer_specs[0].transfer_spec.paths[0].fileName
              });
              let uploadInfo = {
                id: res.transfer_specs[0].transfer_spec.paths[0].fileId,
                name: res.transfer_specs[0].transfer_spec.paths[0].fileName,
                size: 0
              }
              this.file.list.forEach(el => {
                if(el.id == res.transfer_specs[0].transfer_spec.paths[0].fileId){
                  el.uuid = res.transfer_specs[0].uuid
                }
              })
              this.pushList(uploadInfo)
              store.commit("setMessageList", this.messageList);
              let nowLength1 = document.querySelectorAll('.uploadLoadingList .content ul li').length;
              this.nowLength1 = nowLength1
            }
          });
        },
        complete: f => {
          f.targetPath = f.serverpath;
          //   this.messageList.forEach(el => {
          //     if (el.fileId === f.id) {
          //       this.$set(el, "typeName", "上传成功");
          //     }
          //   });
          let messageList = Array.from(new Set(this.messageList));

          messageList = messageList.filter(el => {
            return el.status_name != "正在上传";
          });
          store.commit("setMessageList", messageList);
          this.file.list.forEach(i => {
            if (i.id === f.id) {
              this.$set(i, "hideasset", true);
            }
          });

          // this.addAssetsToPage([f])
          this.addFilePromises.push(this.addAssetsToPage([f]));
        },
        delete: f => {
          // 删除上传过程中的文件
          if (f.pending) {
            this.deleteAsset(f.idstring, this.file.list);
            return;
          } else {
            fileControls.asperaWeb.removeTransfer(f.uuid);
            this.delItem(this.file.list, f.id);
            let id = document.getElementById(f.id).parentNode;
            id.remove();
            let nowLength1 = document.querySelectorAll('.uploadLoadingList .content ul li').length;
            this.nowLength1 = nowLength1
          }
        }
      },
      addFilePromises: [],
      hasHttp: false,
      hasAspera: false,
      file_format_types: {}
    }
  },
  watch: {
    addFilePromises: {
      deep: true,
      handler: function (n) {
        const leftWithoutPending = this.file.list.filter(
          l => !l.pending && !l.hideasset
        ).length;

        Promise.all(n).then(() => {
          if (leftWithoutPending === 0) {
            console.log("真真真真真真真真上传完成");
            this.uploading = false;
            console.log(9999999999999111111111111111111111,this.file.list)
            this.r('uploadComplete')
            // this.page.pageIndex = 1;
            // this.getList();
            // this.passUploading();
            // this.$emit("getComplete", "");
          }
        });
      }
    }
  },
  methods: {
    toChart() {
      common.jumpOut(this.config)
    },
    getSendList() {
      common.myFetch(config.apis.pushinglist).then(res => {
        console.log(res)
        if(res){
          this.list = res.list
        }else{
          this.list = []
        }
        // this.list = (res && res.list) || []
      })
    },
    open(c, r) {
      this.config = c
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    cancel() {
      this.r(false)
      this.close()
    },
    pushList(detail) {
      console.log(detail)
      let size = this.convertByteToMb(detail.size).toFixed(2)
      // return false;
      let mainDom = this.$refs.downloadList
      let li = document.createElement("li")
      li.className = "listItem" 
      li.innerHTML = `
        <div id="${detail.id}" class="container">
          <div class="left-container">
            <p class="line-container">
              <i style="width: 0%" class="line"></i>
            </p>
          </div>
          <div class="right-container">
            <p>${detail.name}</p>
            <span>0M/${size}M</span>
          </div>
          <div onclick="closeDelBox('${detail.id}')" class="close">x</div>
        </div>
      `;
      let bj = this.$refs.downloadList.querySelectorAll('li')[0]
      mainDom.insertBefore(li,bj);
      // var index = 1
      // let list = this.list
      // setInterval(() => {
      //   if(list.length<5){
      //     list.push(index) 
      //     this.list = list
      //     index = index + 1
      //     let mainDom = this.$refs.downloadList
      //     let li = document.createElement("li")
      //     li.className = "listItem" 
      //     li.innerHTML = index;
      //     let bj = this.$refs.downloadList.querySelectorAll('li')[0]
      //     mainDom.insertBefore(li,bj);
      //   }
      // }, 3000);
    },
    pushList1() {
      let mainDom = this.$refs.downloadList
      let li = document.createElement("li")
      li.className = "listItem" 
      li.innerHTML = `
        <div onclick="closeDelBox(12)" class="close">x</div>
        <div id="123" class="container">
          <div class="left-container">
            <p class="line-container">
              <i style="width: 0%" class="line"></i>
            </p>
          </div>
          <div class="right-container">
            <p>123123</p>
            <span>0M/123123M</span>
          </div>
        </div>
      `;
      let bj = this.$refs.downloadList.querySelectorAll('li')[0]
      mainDom.insertBefore(li,bj);
    },
    async closeDelBox(i) {
      // console.log(i)
      // console.log(this.file.list)
      let msg = `确定取消上传？`;
      const confirm = await this.$confirm(msg);
      if(!confirm) return
      // console.log(i.getAttribute('id'))
      let id = ''
      // if(i.getAttribute('id')){
      //   id = i.getAttribute('id');
      // }else{
      //   id = i
      // }
      id = i;
      this.file.list.forEach(el => {
        if(el.id == id){
          // console.log(el,config.apis.File_cancel)
          this.handelCancelProgress(el)
        }
      })

    },
    loadJQ() {
      if (window.$) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.jqjs);
    },
    loadAW4() {
      if (window.AW4) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.aw4js);
    },
    loadAW4Config() {
      if (window.AW4.ConnectInstaller) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.aw4config);
    },
    loadAspera() {
      return Promise.all([this.loadJQ(), this.loadAW4()]).then(() => {
        return this.loadAW4Config().then(() => {
          return this.loadAsperaJS();
        });
      });
    },
    loadAsperaJS() {
      // 加载js文件
      if (window.fileControls) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.asperajs);
    },
    resetAsperaCheck() {
      // 重置aspera检测，恢复初始状态
      if (this.aspera.checkInstalled) {
        clearTimeout(this.aspera.checkInstalled);
        this.aspera.checkInstalled = null;
        this.$set(this.aspera, "needInstall", false);
      }
    },
    __parseFileName(path) {
      // 解析文件路径中的文件名
      if (/Win/.test(navigator.platform)) {
        return path.substring(path.lastIndexOf("\\") + 1);
      } else {
        return path.substring(path.lastIndexOf("/") + 1);
      }
    },
    generateServerPath(f) {
      // 生成服务器端路径
      let serverpath = "";
      const uniname = common.uniKey();
      const platform = common.getPlatform();
      const ext = f.filename.split(".").pop();
      const asperaPath = window._XN_upCfg.asperaPath;
      const fileNameId = window._XN_upCfg.fileNameId;
      const path = `${asperaPath}/${fileNameId}${platform}${uniname}.${ext}`;
      f.id = uniname;
      serverpath = path;

      return serverpath;
    },
    asperaUpload() {
      if (this.uploading) return;
      fileControls.asperaWeb.showSelectFileDialog({
        success: res => {
          const files = [];

          res.dataTransfer.files.forEach(i => {
            if (i.size <= this.aspera.maxSize) {
              console.log(i);
              let ext = i.name.split(".").pop();
              ext = ext.toLowerCase();
              // const types = this.aspera.filetypes
              if (this.aspera.filetypes.indexOf(ext) === -1) {
                this.$toast("无法上传不支持的格式");
              } else {
                i.filename = this.__parseFileName(i.name);
                i.serverpath = this.generateServerPath(i);
                i.percent = 0;
                files.push(i);
              }
            } else {
              this.$toast("上传文件不能超出限制");
            }
          });

          this.aspera.files = files;
          console.log(this.aspera.files)
          this.file.list = this.aspera.files.concat(this.file.list);
          // if (this.aspera.files.length > 0) {
          //   this.uploading = true;
          // }
          this.aspera.files.forEach(f => {
            this.aspera.start(f);
          });
        }
      });
      // fileControls.showSelectFileDialog(document.body, config, moid, userid, true);
    },
    checkAspera() {
      // let checkFailTime = 0;
      this.$set(this.aspera, "needInstall", true);
      this.loadAspera().then(() => {
        const container = $(document.body);
        fileControls.initAsperaConnect(container, (installed, updatable) => {
          // 检测aspera插件是否安装可用
          console.log(installed);
          if (!installed) {
            // this.$toast('请安装aspera客户端')
            this.$set(this.aspera, "needInstall", true);
            this.checkFailTime++;
            this.aspera.checkInstalled =
              this.aspera.checkInstalled ||
              setTimeout(() => {
                this.checkAspera();
              }, 1000);

            if (this.checkFailTime == 5) {
              clearTimeout(this.aspera.checkInstalled);
              this.aspera.checkInstalled = null;
              this.$confirm(
                "未检测到高速上传插件，暂时无法使用该服务是否前往下载该插件？"
              ).then(r => {
                if (r) {
                  window.open(config.asperapage, true);
                }
              });
            }
          }

          if (updatable) {
            this.$toast("请升级到最新客户端");
          }

          if (installed) {
            this.$set(this.aspera, "needInstall", false);
            this.resetAsperaCheck();
            this.asperaUpload();

            fileControls.asperaWeb.addEventListener("transfer", (e, status) => {
              if (status.result_count <= 0) return;
              const filelist = status.transfers.filter(
                i => i.current_file || i.status == "completed"
              );
              this.handleAsperaProgress(filelist);
            });
          }
          // 检测aspera插件是否安装可用
        });
      });
    },
    handleAsperaProgress(list) {
      // console.log(list)
      this.file.list.forEach(i => {
        console.log(i)
        list.forEach(j => {
          console.log(j)
          if (!i.hideasset && i.filename === j.title) {
            if (j.status === "failed") {
              let id = document.getElementById(i.id).parentNode;
              id.remove();
              this.$toast(j.error_desc);
              let nowLength1 = document.querySelectorAll('.uploadLoadingList .content ul li').length;
              this.nowLength1 = nowLength1
              return;
            }

            let a = this.convertByteToMb(j.bytes_written).toFixed(2)
            let b = this.convertByteToMb(j.bytes_expected).toFixed(2)
            let id = document.getElementById(i.id);
            id.querySelectorAll('.left-container > .line-container > .line')[0].style.width = j.percentage*100 + '%'
            id.querySelectorAll('.right-container > span')[0].innerHTML = `${a}M/${b}M`

            // this.$set(i, "percent", j.percentage * 100);
            // this.$set(i, "total", this.rcsDvs(j.bytes_expected));
            // this.$set(i, "loaded", this.rcsDvs(j.bytes_written));
            // this.$set(i, "title", j.title);
            // this.$set(i, "uuid", j.uuid);
            if (j.status === "completed") {
              this.aspera.complete(i);
              let id = document.getElementById(i.id).parentNode;
              id.remove();
              let nowLength1 = document.querySelectorAll('.uploadLoadingList .content ul li').length;
              this.nowLength1 = nowLength1
              console.log("complete", i);
            }
          }
        });
      });
    },
    filterFiles(f, size) {
      // 大小超出的文件删除出去
      let files = [];
      files = f.filter(i => {
        return i.size < size;
      });

      files.forEach(el => {
        el.fileId = el.id;
      });

      this.file.list.forEach((j, k) => {
        let idx = files.length - 1;
        while (idx >= 0) {
          if (files[idx].name === j.name && !j.pending && !j.hideasset) {
            this.$toast("请不要同时上传相同的文件");
            files.splice(idx, 1);
          }

          idx -= 1;
        }
      });

      return files;
    },
    checkFileType(f) {
      // 检查文件类型
      let type = "";
      let ext = f.name.split(".").pop() || f.path.split(".").pop();
      ext = ext.toLowerCase();

      if (this.pic.types.indexOf(ext) > -1) {
        type = 1;
      } else if (this.video.types.indexOf(ext) > -1) {
        type = 2;
      } else if (this.audio.types.indexOf(ext) > -1) {
        type = 3;
      }

      return type;
    },
    async addAssetsToPage(data) {
      console.log(data);
      const filelist = [];
      data.forEach(i => {
        const type = this.checkFileType(i);
        // 将文件名改为截取前40位加后缀名
        const fileName = i.pureName || i.title || i.filename || i.name || "";
        const nameParts = fileName.split(".");
        const ext = nameParts.pop();
        let nameLeft = nameParts.join(".");
        nameLeft = nameLeft.substr(0, 40);
        const filetitle = `${nameLeft}.${ext}`;

        const file = {
          type: type,
          title: filetitle,
          path: i.targetPath || i.path
        };

        filelist.push(file);
      });

      const info = { file_info: JSON.stringify(filelist) };
      return common.myFetch(config.apis.File_add, info).then(r => {
        if (r) {
          // this.getFileAssets();
          let nowLength1 = document.querySelectorAll('.uploadLoadingList .content ul li').length;
          this.nowLength1 = nowLength1
        }
      });
    },
    delItem(data, id) {
      // 从数组中移除取消上传的项
      data.forEach((d, i) => {
        if (d.id === id) {
          data.splice(i, 1);
        }
      });
    },
    deleteAsset(idstring, list) {
      // 删除资源文件
      const info = {
        idstring: idstring
      };
      common.myFetch(config.apis.File_delete, info).then(r => {
        if (r) {
          this.$toast(r);

          list.some((d, i) => {
            if (d.idstring === idstring) {
              list.splice(i, 1);
              // 通知编辑器 删除 该素材
              // this.$emit("deleteMedia", {
              //     src: d.url,
              //     idstring,
              //     type: this.navOn
              // });
              return true;
            }
          });
        }
      });
    },
    convertByteToGb(n) {
      // 将字节转换为GB
      return n / 1024 / 1024 / 1024;
    },
    convertByteToMb(n) {
      // 将字节转换为MB
      return n / 1024 / 1024;
    },
    handelCancelProgress(f) {
      // 删除上传列表中文件
      console.log(f)
      if (f.uuid) {
        this.aspera.delete(f);
      } else {

        if(this.cancel_enable){
          const info = {
            token: f.parameters.token
          }
          common.myFetch(config.apis.File_cancel, info).then(e => {
            // console.log(e)
          })
        }
        
        this.file.cancelOne(f);
      }

      // 检测队列剩余资源，如果为空则需要恢复uploading状态
      const leftWithoutPending = this.file.list.filter(
        l => !l.pending && !l.hideasset
      ).length;
      if (leftWithoutPending === 0) {
        this.uploading = false;
        // this.passUploading();
      }
    },
    getAsperaConfig() {
      // 获取aspera上传配置
      return common.myFetch(config.apis.File_Aspera).then(r => {
        if (r) {
          const types = r.file_format;
          this.file_format_types = types;
          this.hasHttp = r.normal_upload;
          this.hasAspera = r.aspera_upload;
          this.pic.types = types.image;
          this.video.types = types.video;
          this.audio.types = types.audio;
          // window._XN_upVdoTps = types.video // 视频格式前缀为source，此处为传入streamjs
          this.aspera.config = r.upload_config;
          const filetypes = types.image.concat(types.video).concat(types.audio);
          this.aspera.filetypes = filetypes;
          const extFilters = filetypes.map(f => `.${f}`);
          this.file.config.extFilters = extFilters;

          this.file.config.maxSize =
            r.file_format.file_size || this.file.config.maxSize;
          this.aspera.maxSize = r.file_format.file_size || this.aspera.maxSize;

          this.file.description = `素材格式：${filetypes.join(
            ","
          )} <br><br> 视频、音频每种素材不超过10个，单个素材不超过${this.convertByteToGb(
            this.aspera.maxSize
          )}GB`;

          window._XN_upCfg = {
            asperaPath: r.aspera_path,
            httpPath: r.original_path,
            fileNameId: r.filename_id
          };
        }
      });
    },
    loadjs() {
      // 加载js文件
      if (window.Stream) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.streamjs);
    },
    load() {
      // 加载js文件
      // return common.load(config.streamjs)
      return this.getAsperaConfig().then(() => {
        return Promise.all([this.loadjs(), this.getConfig()]);
      });
    },
    getConfig() {
      return common.getFileConfigs().then(r => {
        this.baseUrl = r.url;
        // this.baseUrl = 'http://upload2-ai.smgtech.net';
        this.appId = r.app_id;
        this.appSecret = r.app_secret;
        this.cancel_enable = r.cancel_enable;
        const dataConfig = {
          tokenURL: this.baseUrl + config.apis.File_get_token,
          uploadURL: this.baseUrl + config.apis.File_post,
          postVarsPerFile: {
            appId: this.appId,
            appSecret: this.appSecret
          }
        };

        Object.assign(this.baseConfig, dataConfig);
        return true;
      });
    },
    configFile() {
      // 配置文件
      const config = Object.assign({}, this.baseConfig, this.file.config,common.userKeys());
      this.file.stream = new Stream(config);
    },
    init() {
      // 模块初始化
      this.load().then(() => {
        // this.configPic()
        // this.configVideo()
        // this.configAudio()
        this.configFile();
      });
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.init()
    // })
  },
  created() {
    let that = this
    // window.closeDelBox=that.closeDelBox;
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';

  .chatGptMessage {
    position: fixed;
    z-index: 999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    bottom: 260px;
    right: -5px;
    // z-index: 1;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(185,195,195,0.4);
    user-select: none;
    cursor: pointer;

    &:hover {
      background: #41B48C;

      & > i {
        display: block;
        width: 24px;
        height: 24px;
        background: url('./assets/chatOn.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }

      & > span {
        font-size: 10px;
        line-height: 12px;
        color: #FFFFFF;
        font-weight: bold;
        margin-top: 1px;
        font-family: Arial, Helvetica, sans-serif;
      }

      p {
        display: block;
      }
    }

    & > i {
      display: block;
      width: 24px;
      height: 24px;
      background: url('./assets/chat.png') no-repeat;
      background-position: center center;
      background-size: 100% 100%;
    }

    & > span {
      font-size: 10px;
      line-height: 12px;
      color: #0D0D21;
      font-weight: bold;
      margin-top: 1px;
      font-family: Arial, Helvetica, sans-serif;
    }

    p {
      display: none;
      position: absolute;
      top: 79px;
      right: 5px;
      z-index: 999;
      padding: 5px 12px;
      box-sizing: border-box;
      background: rgba(30, 39, 34, 0.9);
      font-size: 12px;
      line-height: 21px;
      color: #FFFFFF;
      border-radius: 6px;
      width: 168px;

      i {
        position: absolute;
        top: -9px;
        right: 18px;
        display: block;
        width: 16px;
        height: 9px;
        background: url('./assets/arrow.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }
    }

    .uploadIcon-container {
      position: fixed;
      display: flex;
      justify-content: center;
      align-items: center;
      right: -14px;
      bottom: 170px;
      width: 56px;
      height: 56px;
      background: rgba(65, 180, 140, 0.15);
      border-radius: 28px;
      user-select: none;
      cursor: pointer;

      & > img {
        width: 20px;
        height: 20px;
      }

      &>.num {
        position: absolute;
        top: 0;
        left: 0;
        width: 22px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        background: #FF555A;
        border-radius: 9px;
        font-weight: bold;
        color: #FFFFFF;
        font-size: 14px;
      }
    }

    .fileSendList {
      display: flex;
      flex-direction: column;
      position: fixed;
      bottom: 108px;
      right: 0px;
      width: 320px;
      height: 366px;
      background: #F9F9F9;
      box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
      border-radius: 4px;
      overflow: hidden;

      &>.title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 320px;
        height: 50px;
        background: #F9F9F9;
        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
        border-radius: 4px 4px 0px 0px;
        padding: 0 20px;
        box-sizing: border-box;

        &>p {
          font-size: 16px;
          color: #050F0F;
          font-weight: bold;
        }

        img {
          user-select: none;
          cursor: pointer;
        }
      }

      &>.content {
        flex: 1;
        overflow-y: auto;
        margin-top: 10px;

        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          background: #ddd;
          border-radius: 4px;
        }
      }
    }

    ul {
      display: flex;
      flex-direction: column;
      padding: 0 20px;
      box-sizing: border-box;

      li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 66px;
        padding: 10px 0;
        border-bottom: 1px solid #DCDCDC;
        box-sizing: border-box;

        .l {
          position: relative;
          width: 82px;
          height: 46px;
          margin-right: 10px;
          border-radius: 4px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }

          .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);

            i {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              display: block;
              width: 16px;
              height: 16px;
              background: url('../../assets/img/common/complete.png') no-repeat;
              background-size: 100% 100%;
              background-position: center center;

              &.on {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -8px;
                margin-left: -8px;
                display: block;
                width: 16px;
                height: 16px;
                background: url('../../assets/img/common/loading.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                animation: rotateAll 1.2s linear infinite;
              }
            }
          }
        }

        .r {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-width: 0;

          .t {
            width: 100%;
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 1px;
            color: #050F0F;
            font-weight: bold;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .b {
            width: 100%;
            font-size: 12px;
            line-height: 17px;
            color: #829191;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }

      //  li.listItem {
      //    display: flex;
      //    flex-direction: row;
      //    width: 320px;
      //    height: 84px;
      //    border-radius: 4px;
      //    background: #F9F9F9;
      //    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.1);
      //    animation: translateXShow 0.3s linear;
      //    margin-bottom: 10px;
      //  }
    }
  }

  @keyframes translateXShow {
    0% {
      transform: translateX(350px);
    }

    100% {
      transform: translateX(10px);
    }
  }

  @keyframes rotateAll{
    0% {
      transform: rotate(0deg)
    }
    100% {
      transform: rotate(360deg)
    }
  }
</style>

<style lang="less">
  .chatGptMessage {

    li.listItem {
      position: relative;
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 66px;
      // border-radius: 4px;
      background: #F9F9F9;
      // box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.1);
      // animation: translateXShow 0.3s linear;
      // margin-bottom: 10px;
      // padding: 22px 16px;
      border-bottom: 1px solid #DCDCDC;
      box-sizing: border-box;

      &:nth-last-of-type(1) {
        border-bottom: none;
      }

      .container {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 280px;

        .left-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: 82px;
          width: 82px;
          height: 46px;        
          background: rgba(0, 0, 0, 0.7);
          border-radius: 4px;
          margin-right: 10px;

          .line-container {
            position: relative;
            width: 62px;
            height: 6px;
            border-radius: 3px;
            border: 1px solid #FFF;
            box-sizing: border-box;

            .line {
              position: absolute;
              top: -1px;
              left: -1px;
              width: 20%;
              height: 6px;
              background: #FFF;
              border-radius: 3px;
            }
          }
        }

        .right-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 168px;
          // flex: 1;
          height: 100%;

          p {
            font-size: 14px;
            line-height: 20px;
            height: 20px;
            font-weight: bold;
            color: #050F0F;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }

          span {
            font-size: 12px; 
            font-weight: 500;
            color: #829191;
            line-height: 17px;
          }
        }

        .close {
          // display: flex;
          // justify-content: center;
          // align-items: center;
          font-weight: bold;
          color: #B9C3C3;
          width: 10px;
          height: 10px;
          line-height: 10px;
          user-select: none;
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }
  }

  @keyframes translateXShow {
    0% {
      transform: translateX(350px);
    }

    100% {
      transform: translateX(10px);
    }
  }
</style>
